'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = meta;

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _actionTypes = require('../actionTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  meta: _config2.default.app.head.meta
};

var replaceTag = function replaceTag(array, property, content) {
  var idx = array.findIndex(function (item) {
    return item.property == property;
  });
  return [].concat((0, _toConsumableArray3.default)(array.slice(0, idx)), [{ property: property, content: content }], (0, _toConsumableArray3.default)(array.slice(idx + 1)));
};

function meta() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];


  switch (action.type) {
    case _actionTypes.userActions.LOAD_USER_OUTFEATS.COMPLETED:
      var newMeta = replaceTag(state.meta, 'og:creator', action.result.user.username);
      if (action.result.outfeats && action.result.outfeats.length > 0) {
        newMeta = replaceTag(state.meta, 'og:image', 'https://s3.amazonaws.com/outfeats/' + action.result.outfeats[0].images[0]);
      } else {
        newMeta = replaceTag(state.meta, 'og:image', action.result.user.profile_picture);
      }

      newMeta = replaceTag(newMeta, 'og:description', 'Outfeats created by @' + action.result.user.username);
      return {
        title: action.result.user.full_name,
        meta: newMeta
      };
    case _actionTypes.outfeatActions.FIND_OUTFEAT.COMPLETED:
      var outfeat = action.result.entities.outfeats[action.result.result.outfeats];
      if (outfeat && outfeat.id) {
        var newMeta = replaceTag(state.meta, 'og:image', 'https://s3.amazonaws.com/outfeats-thumbnails/' + outfeat.images[0]);
        if (outfeat.user) {
          newMeta = replaceTag(state.meta, 'og:creator', outfeat.user.full_name);
        }
        var description = '';
        outfeat.items.forEach(function (item, index) {
          description += item.title;
          if (index + 1 !== outfeat.items.length) {
            description += ', ';
          }
        });
        newMeta = replaceTag(newMeta, 'og:description', description);
        return {
          title: 'Outfeats',
          meta: newMeta
        };
      }
      return state;
    default:
      return state;
  }
}
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/meta.js
 ** module id = 1120
 ** module chunks = 0
 **/